export default class OfferOsppUsers {
  constructor($scope, OfferService) {
    $scope.tabs = [
      {
        title: 'Activated OSPP',
        buyers: []
      },
      {
        title: 'Need Activation',
        buyers: []
      },
      {
        title: 'Expired Policy',
        buyers: []
      },
      {
        title: 'Special Group',
        buyers: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.load_data = function() {
      $scope.loading = true;
      OfferService.get_ospp_users(window.offer_id).then(function(response) {
        $scope.tabs[0].buyers = response.data.activated_buyers;
        $scope.tabs[1].buyers = response.data.need_activation_buyers;
        $scope.tabs[2].buyers = response.data.expired_policy_buyers;
        $scope.tabs[3].buyers = response.data.special_group_buyers;
        $scope.loading = false;
      });
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.offer_id = window.offer_id;
      $scope.load_data();
    };

    $scope.init();
  }
}

OfferOsppUsers.$inject = ['$scope', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-ospp-users.ctrl.js